export default function(fields, oldQuestions) {
  const otherQuestions = oldQuestions.filter(item => item.id !== fields.id)

  let popQuestion = oldQuestions.filter(item => item.id === fields.id)[0]

  popQuestion = {
    ...popQuestion,
    translatedText: fields.questionText,
    questionType: fields.questionType,
    translationKey: undefined,
    isOptional: fields.isOptional,
    parentalConsentHide: fields.parentalConsentHide,
    parentalConsentOnly: fields.parentalConsentOnly,
    profileQuestionOptions: fields.questionOptions.map(item => ({
      translatedText: item.value,
      temporaryId: item.id
    }))
  }

  return {
    profileQuestions: otherQuestions.concat(popQuestion)
  }
}
